import styled from 'styled-components';

import P from 'components/typo/P/styled/PContainer';

import Item from '../PriceItem/Item/styled/Wrap';

export default styled.div`
  margin: 0 auto;
  max-width: 500px;

  > ${Item} {
    text-align: center;
    margin-bottom: 32px;
  }

  ${P} {
    margin-top: 40px;
  }
`;
